/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relativehouragoone3Inputs */

const en_relativehouragoone3 = /** @type {(inputs: Relativehouragoone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 hour ago`)
};

const pt_relativehouragoone3 = /** @type {(inputs: Relativehouragoone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`há 1 hora`)
};

/**
* | output |
* | --- |
* | "1 hour ago" |
*
* @param {Relativehouragoone3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const relativehouragoone3 = /** @type {((inputs?: Relativehouragoone3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relativehouragoone3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_relativehouragoone3(inputs)
	return pt_relativehouragoone3(inputs)
});
export { relativehouragoone3 as "relativeHourAgoOne" }